// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer-kpIKAmda","foot_link":"foot_link-2UDyo9lv","list":"list-2kisTPOL","link":"link-9liQLH7C","copyright":"copyright-Vqbxlom1"};